import React from "react";
import Carousel from "react-multi-carousel";

// function IndicatorIcon() {
//   return (
//     <div className="sm:w-1/2 w-3/4 flex m-auto mt-6 justify-between max-w-screen-sm">
//       {" "}
//       <div className="p-[5px] hover:border">
//         {" "}
//         <svg
//           viewBox="0 0 8 12"
//           className=" fill-[#1C1B1F] hover:fill-slate-500 w-2 h-3"
//           xmlns="http://www.w3.org/2000/svg"
//         >
//           <path
//             d="M3.05375 6.00043L7.65375 1.40043L6.6 0.34668L0.946247 6.00043L6.6 11.6542L7.65375 10.6004L3.05375 6.00043Z"
//             // fill="#1C1B1F"
//           />
//         </svg>
//       </div>{" "}
//       {/* ellipse */}
//       <div className="flex justify-center items-center gap-1">
//         <div className="w-[5px] h-[5px]  bg-grey-lighActive rounded-full"></div>{" "}
//         <div className="w-[6px] h-[6px] bg-grey-normal rounded-full"></div>
//         <div className="w-[5px] h-[5px] bg-grey-lighActive rounded-full"></div>
//       </div>
//       <div className="p-[5px]">
//         <svg
//           viewBox="0 0 8 12"
//           className=" fill-[#1C1B1F] w-2 h-3 "
//           xmlns="http://www.w3.org/2000/svg"
//         >
//           <path
//             d="M4.94625 6.00043L0.346252 1.40043L1.4 0.34668L7.05375 6.00043L1.4 11.6542L0.346252 10.6004L4.94625 6.00043Z"
//             // fill="#1C1B1F"
//           />
//         </svg>
//       </div>
//     </div>
//   );
// }

function IndicatorIcon({ previous, next, goToSlide, ...rest }) {
  // These props come from react-multi-carousel and allow interaction with the carousel
  const { carouselState } = rest;
  const currentSlide = carouselState?.currentSlide ?? 0;
  const totalItems = carouselState?.totalItems ?? 0;
  const totalItems2 = totalItems + 2 - totalItems / 2;
 

  // const totalItems = 4;
  const indicators = [];
  for (let i = 2; i < totalItems2; i++) {
    indicators.push(
      <div
        key={i}
        onClick={() => goToSlide(i)}
        className={`w-[5px] h-[5px] md:w-2 md:h-2 rounded-full cursor-pointer ${
          i === currentSlide
            ? "bg-grey-normal w-[6px] h-[6px] md:w-3 md:h-3"
            : "bg-grey-lighActive"
        }`}
      />
    );
  }

  return (
    <div className="sm:w-1/2 w-3/4 flex m-auto mt-6 justify-between max-w-screen-sm">
      {/* Previous Button */}
      <div onClick={() => previous()} className="p-[5px] cursor-pointer">
        <svg
          viewBox="0 0 8 12"
          className="fill-[#1C1B1F] hover:fill-slate-500 w-2 h-3  md:w-4 md:h-5"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M3.05375 6.00043L7.65375 1.40043L6.6 0.34668L0.946247 6.00043L6.6 11.6542L7.65375 10.6004L3.05375 6.00043Z" />
        </svg>
      </div>

      {/* Indicators */}
      <div className="flex justify-center items-center gap-1">{indicators}</div>

      {/* Next Button */}
      <div onClick={() => next()} className="p-[5px]  cursor-pointer">
        <svg
          viewBox="0 0 8 12"
          className="fill-[#1C1B1F] w-2 h-3 md:w-4 md:h-5"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M4.94625 6.00043L0.346252 1.40043L1.4 0.34668L7.05375 6.00043L1.4 11.6542L0.346252 10.6004L4.94625 6.00043Z" />
        </svg>
      </div>
    </div>
    // <div className="">
    //   {" "}
    //   <button
    //     className={currentSlide === 0 ? "disable" : ""}
    //     onClick={() => previous()}
    //   >
    //     {" "}
    //     prev{" "}
    //   </button>
    //   <button onClick={() => next()}> next </button>
    //   <button onClick={() => goToSlide(currentSlide + 1)}>
    //     {" "}
    //     Go to any slide{" "}
    //   </button>
    // </div>
  );
}

export default IndicatorIcon;
